<template>
  <v-card
    elevation="0"
    tile
    :loading="loading"
    style="z-index: 100; height: 100vh; width: 100vw"
  >
    <v-row class="fill-height ma-0" align="center" justify="center">
      <v-col cols="auto" class="text-center">
        <template v-if="error">
          <v-icon size="48" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
          <div class="text-h6 mb-2">Não foi possível fazer o acesso automático</div>
          <div class="text-body-2 grey--text mb-6">{{ error }}</div>
          <v-btn color="primary" elevation="0" @click="goToLogin">Ir para o login</v-btn>
        </template>
        <template v-else>
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <div class="text-body-1 grey--text">Autenticando, aguarde...</div>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import axios from 'axios'
import { saveAuth } from '@/services/authService'

export default {
  name: 'AuthRedirect',

  data() {
    return {
      loading: true,
      error: null,
    }
  },

  mounted() {
    this.autoLogin()
  },

  methods: {
    goToLogin() {
      this.$router.push('/entrar')
    },

    autoLogin() {
      const token = this.$route.params.token

      if (!token) {
        this.error = 'Token inválido ou ausente.'
        this.loading = false
        return
      }

      axios
        .post(`${this.$apiURL}auth/auto`, { token })
        .then((response) => {
          const data = response.data.data
          const { redirect } = data

          saveAuth(data, { keepConnected: true })

          this.loading = false

          const loc = redirect?.location || ''
          const destination = loc
            ? (loc.startsWith('/') ? loc : `/${loc}`)
            : '/app/home'

          window.location.href = destination
        })
        .catch((err) => {
          this.loading = false
          const msg =
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? Object.values(err.response.data.errors[0])[0][0]
              : 'Ocorreu um erro inesperado. Tente novamente.'
          this.error = msg
        })
    },
  },
}
</script>
